import PropTypes from "prop-types";

function Item({ icon, content }) {
  return (
    <div className="inline-flex items-center gap-[8px] desktop:gap-[10px]">
      <span className="inline-flex justify-center items-center w-[30px] h-[30px]">{icon}</span>
      <p className="subtext text-black">{content}</p>
    </div>
  );
}

Item.propTypes = {
  icon: PropTypes.node.isRequired,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
};

export default Item;
